import { providerNameMapper } from '@/modules/developerTools/pages/languageModels/helper';
import { ProviderName } from '@/modules/developerTools/types';

export const deskSearchTerms = (desk: { name: string }): string[] => [desk.name];

export const brainSearchTerms = (brain: { name: string }): string[] => [brain.name];

export const memberSearchTerms = (member: { name: string; email: string }): string[] => [
  member.name,
  member.email,
];

export const languageModelName = (
  model: { language_model_id: string; model: string },
  languageModelNames: Record<string, string>
): string => languageModelNames[model.language_model_id] || model.model;

export const languageModelSearchTerms = (
  model: { language_model_id: string; model: string; provider: string },
  languageModelNames: Record<string, string>
): string[] => [
  languageModelName(model, languageModelNames),
  providerNameMapper(model.provider as ProviderName),
];
